var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',_vm._g(_vm._b({staticClass:"text-body-1 pa-2"},'h2',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }